import { memo, useEffect, useCallback, useState } from "react";
import Form from "../Form.js";
import { useSnackbar } from "../../utils/index.js"
import Spinner from "../Spinner.js"
import {
    getOrganizations,
    getOrganization,
    getUsersData,
    getUserRole,
    createInspector,
    updateInspector,
    deleteInspector,
} from "../../api/index.js";
import { IconButton, Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AreYouSurePopup from "../popups/AreYouSurePopup.js";



const InspectorForm = ({
    datePickerWidth = "595px",
    isCreate, // Declares if the form is used for creation (true) or update (false)
    fetchedInspector = {}, // Used in update ~ the inspector to be updated object
    setFetchedInspector, // Used in update ~ the set method of the inspector to be updated 
    inspectorId = {}, // Used in update ~ the id of the inspector to be updated
    setIsInspectorSelected, // Used in update ~ declares if inspector is selected to be updated
    isFromList, // Declares if the form is rendered in list page or not 
    setIsCreateOpen, // Used when isFromList is true ~ to set the open status of the modal
    fetchListData // Used when isFromList is true ~ to update the table
}
) => {
    const [fetchedOrganizations, setFetchedOrganizations] = useState([]);
    const [organizationDropdownValues, setOrganizationDropdownValues] = useState([]);
    const [fetchedOrganization, setFetchedOrganization] = useState(null);

    const [fetchedUsers, setFetchedUsers] = useState([]);
    const [userDropdownValues, setUserDropdownValues] = useState([]);

    const [userRole, setUserRole] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            try {
                const { organization } = await getOrganization();
                setFetchedOrganization(organization);

                const { organizations } = await getOrganizations();
                setFetchedOrganizations(organizations);
                const orgDropdownArr = [];
                for (var org of organizations) {
                    orgDropdownArr.push({ value: org.name, text: org.name });
                }
                setOrganizationDropdownValues(orgDropdownArr);

                const { users } = await getUsersData();
                setFetchedUsers(users);
                const usersDropdownArr = [];
                for (var user of users) {
                    usersDropdownArr.push({ value: user.username, text: user.username });
                }
                setUserDropdownValues(usersDropdownArr);

                const { role } = await getUserRole();
                setUserRole(role);
            } catch (err) {
                error(err)
            }
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const createFormContent = [
        {
            customType: "input",
            id: "lastName",
            type: "text",
            placeholder: "Επώνυμο",
            required: true,
        },
        {
            customType: "input",
            id: "firstName",
            type: "text",
            placeholder: "Όνομα",
            required: true,
        },
        {
            customType: "input",
            id: "address",
            type: "text",
            placeholder: "Διεύθυνση",
        },
        {
            customType: "input",
            id: "city",
            type: "text",
            placeholder: "Πόλη",
            required: true
        },
        {
            customType: "input",
            id: "county",
            type: "text",
            placeholder: "Νομός",
        },
        {
            customType: "input",
            id: "postalCode",
            type: "text",
            placeholder: "Τ.Κ",
        },
        {
            customType: "input",
            id: "phoneNumber",
            type: "text",
            placeholder: "Σταθερό",
        },
        {
            customType: "input",
            id: "cellPhone",
            type: "text",
            placeholder: "Κινητό",
        },
        {
            customType: "dropdown",
            id: "organization",
            items: organizationDropdownValues,
            defaultValue: fetchedOrganization?.name,
            placeholder: "Οργάνωση",
            disabled: true,
        },
        {
            customType: "dropdown",
            id: "user",
            items: userDropdownValues,
            placeholder: "Χρήστης"
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const selectOwnerFormContent = [
        {
            customType: "input",
            id: "lastName",
            type: "text",
            placeholder: "Επώνυμο",
            value: fetchedInspector?.lastName,
            required: true,
        },
        {
            customType: "input",
            id: "firstName",
            type: "text",
            placeholder: "Όνομα",
            value: fetchedInspector?.firstName,
            required: true,
        },
        {
            customType: "input",
            id: "address",
            type: "text",
            placeholder: "Διεύθυνση",
            value: fetchedInspector?.address,
        },
        {
            customType: "input",
            id: "city",
            type: "text",
            placeholder: "Πόλη",
            value: fetchedInspector?.city,
            required: true,
        },
        {
            customType: "input",
            id: "county",
            type: "text",
            placeholder: "Νομός",
            value: fetchedInspector?.county,
        },
        {
            customType: "input",
            id: "postalCode",
            type: "text",
            placeholder: "Τ.Κ",
            value: fetchedInspector?.postalCode,
        },
        {
            customType: "input",
            id: "phoneNumber",
            type: "text",
            placeholder: "Σταθερό",
            value: fetchedInspector?.phoneNumber,
        },
        {
            customType: "input",
            id: "cellPhone",
            type: "text",
            placeholder: "Κινητό",
            value: fetchedInspector?.cellPhone,
        },
        {
            customType: "date-picker",
            id: "outDate",
            type: "desktop",
            label: "Ημ/νια εξόδου",
            width: datePickerWidth,
            background: "third",
            value: fetchedInspector?.outDate,
        },
        {
            customType: "dropdown",
            id: "organization",
            items: organizationDropdownValues,
            defaultValue: fetchedOrganization?.name,
            placeholder: "Οργάνωση",
            disabled: true,
        },
        {
            customType: "dropdown",
            id: "user",
            items: userDropdownValues,
            placeholder: "Χρήστης",
            defaultValue: fetchedInspector?.user,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Αποθήκευση",
        },
    ]


    const handleFormSubmit = async (values) => {
        setIsLoading(true)
        if (values.organization) {
            values.organization = fetchedOrganizations.filter((org) => org.name === values.organization)[0]._id;
        }
        if (values.user) {
            values.user = fetchedUsers.filter((user) => user.username === values.user)[0]._id;
        }

        const { success: successCode, message } = await createInspector(values);
        if (successCode) {
            success(message);
            if (isFromList) {
                setIsCreateOpen(false);
                fetchListData();
            } else {
                window.location.assign('/inspectors/preview');
            }
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const handleUpdateSubmit = async (values) => {
        setIsLoading(true);
        var valuesToSend = { ...values };
        if (valuesToSend.organization) {
            valuesToSend.organization = fetchedOrganizations.find((org) => org.name === valuesToSend.organization)._id;
        }
        if (valuesToSend.user) {
            valuesToSend.user = fetchedUsers.find((user) => user.username === valuesToSend.user)._id;
        }

        const { success: successCode, message } = await updateInspector(inspectorId, valuesToSend);
        if (successCode) {
            if (isFromList) {
                setIsCreateOpen(false);
                fetchListData();
            }
            success(message);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const handleDelete = async () => {
        setIsLoading(true);
        setIsPopupOpen(false);
        const { success: successCode, message } = await deleteInspector(inspectorId);
        if (successCode) {
            success(message);
            if (isFromList) {
                setIsCreateOpen(false);
                fetchListData();
            } else {
                setIsInspectorSelected(false);
            }
        } else {
            error(message);
        }
        setFetchedInspector(null);
        setIsLoading(false);
    }

    return (
        <>
            <AreYouSurePopup
                width={"900px"}
                isOpen={isPopupOpen}
                title="Διαγραφή εκτροφής"
                titleColor="black"
                onClose={() => setIsPopupOpen(false)}
                innerText={`Είστε σίγουροι ότι θέλετε να διαγράψετε τον Ελεγκτή "${fetchedInspector?.lastName} ${fetchedInspector?.firstName}";`}
                declineText="Πίσω"
                onDecline={() => setIsPopupOpen(false)}
                acceptText="Ναι, Διαγραφή Ελεγκτή"
                onAccept={() => handleDelete()}
            />
            <Spinner open={isLoading} />
            <Form content={isCreate ? createFormContent : selectOwnerFormContent} onSubmit={isCreate ? handleFormSubmit : handleUpdateSubmit} toResetForm={false} />
            {userRole === "ADMIN" && !isCreate ? (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <IconButton
                        aria-label="delete"
                        onClick={() => setIsPopupOpen(true)}
                    >
                        <DeleteIcon />
                    </IconButton >
                </Box>
            ) : (
                <></>
            )}
        </>
    )
}

export default memo(InspectorForm)